export default __webpack_public_path__ + "static/media/gold-piece.2949cc5d.svg";